<template>
  <div>

    <v-alert type="info" text class="mt-3 rounded-lg">
      Créez des enquêtes en définissant une date de début et une date de fin, puis ajoutez les détails nécessaires.
    </v-alert>

    <v-card class="shadow rounded-lg mt-3" v-for="(investigation,i) in campaign.investigations" :key="i">

      <v-card-text class="px-4 px-lg-15 py-10">
        <v-row>

          <v-col cols="6">
            <p class="font-weight-medium mb-2 required">
              Titre
            </p>
            <v-text-field v-model="investigation.name.fr"
                          outlined
                          hide-details="auto"
                          dense
                          placeholder="Titre de l'enquête"
            />
          </v-col>

          <v-col cols="6">
            <p class="font-weight-medium mb-2 required ar">
              العنوان
            </p>
            <v-text-field v-model="investigation.name.ar"
                          outlined
                          dense
                          class="ar"
                          hide-details="auto"
                          placeholder="عنوان التحقيق"
            />
          </v-col>

          <v-col cols="6">
            <p class="font-weight-medium mb-2 required">Date de début</p>
            <v-menu
                v-model="investigation.startDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="investigation.start_date"
                    v-bind="attrs"
                    v-on="on"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                    placeholder="Date de début"
                    hide-details="auto"
                />
              </template>
              <v-date-picker color="gifty"
                             v-model="investigation.start_date"
                             @input="investigation.startDateMenu = false"
              />
            </v-menu>
          </v-col>

          <v-col cols="6">
            <p class="font-weight-medium mb-2 required">Date de fin</p>
            <v-menu
                v-model="investigation.endDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="investigation.end_date"
                    v-bind="attrs"
                    v-on="on"
                    readonly
                    prepend-inner-icon="mdi-calendar"
                    outlined
                    dense
                    placeholder="Date de fin"
                    hide-details="auto"
                />
              </template>
              <v-date-picker color="gifty"
                             v-model="investigation.end_date"
                             @input="investigation.endDateMenu = false"
              />
            </v-menu>
          </v-col>

          <v-col cols="12">
            <p class="font-weight-medium mb-2 required">
              Description
            </p>
            <v-textarea v-model="investigation.description.fr"
                        rows="2"
                        hide-details="auto"
                        outlined
                        dense
                        placeholder="Description de l'enquête"/>
          </v-col>

          <v-col cols="12">
            <p class="font-weight-medium mb-2 required ar">
              الوصف
            </p>
            <v-textarea v-model="investigation.description.ar"
                        rows="2"
                        class="ar"
                        hide-details="auto"
                        outlined
                        dense
                        placeholder="وصف التحقيق"/>
          </v-col>

          <v-col cols="12" class="mb-0 pb-0">
            <p class="font-weight-medium mb-2">
              Photos (Sélection multiple)
            </p>
            <v-file-input outlined
                          ref="image"
                          :clearable="false"
                          :disabled="isLoading"
                          :loading="isLoading"
                          accept="image/png,image/jpeg"
                          @change="uploadPhotos($event,i)"
                          multiple
                          show-size
                          chips
                          small-chips
                          counter dense
                          placeholder="Photos de l'enquête(png.jpeg,svg)"/>

            <div v-if="investigation.images && investigation.images.length">
              <div v-for="(image,index) in investigation.images"
                   :key="index"
                   class="d-flex justify-space-between pa-3 rounded grey lighten-4 mb-2">
                <v-avatar size="40" rounded>
                  <v-img :src="FILE_URL + image" class="rounded cursor-pointer"/>
                </v-avatar>
                <v-spacer/>
                <v-btn color="red" icon @click="removePhoto(index,i)">
                  <v-icon>mdi-close-circle</v-icon>
                </v-btn>
              </div>
            </div>

          </v-col>

          <v-col cols="12">
            <p class="font-weight-medium mb-2 required">
              Points gagnants
            </p>
            <v-text-field v-model="investigation.winning_points"
                          hide-details="auto"
                          outlined
                          dense
                          placeholder="Points gagnants de l'enquête"
                          suffix="Pts"/>
          </v-col>

          <v-col cols="12">
            <p class="font-weight-medium mb-2">
              Lien vers le tutoriel
            </p>
            <v-text-field
                v-model="investigation.tutorial_link"
                outlined
                hide-details="auto"
                dense
                placeholder="Entrez le lien du tutoriel"
            />
          </v-col>

          <v-col cols="12">

            <p class="font-weight-medium mb-2">
              Image pour le tutoriel
            </p>
            <v-file-input outlined
                          ref="image"
                          :clearable="false"
                          :disabled="isLoading"
                          :loading="isLoading"
                          :error-messages="errors.tutorial_image"
                          accept="image/png,image/jpeg"
                          @change="uploadTutorialImage($event,i)"
                          show-size
                          chips
                          small-chips
                          counter dense
                          :hide-details="!investigation.tutorial_image"
                          placeholder="Image pour le tutoriel (png.jpeg,svg)"/>

            <div v-if="investigation.tutorial_image">
              <div class="d-flex justify-space-between pa-3 rounded grey lighten-4 mb-2">
                <v-avatar size="40" rounded>
                  <v-img :src="FILE_URL + investigation.tutorial_image" class="rounded cursor-pointer"/>
                </v-avatar>
                <v-spacer/>
                <v-btn color="red" icon @click="investigation.tutorial_image = ''">
                  <v-icon>mdi-close-circle</v-icon>
                </v-btn>
              </div>
            </div>

          </v-col>

          <v-col cols="6">
            <p class="font-weight-medium mb-2 required">
              Nombre total de réponses
            </p>
            <v-text-field
                v-model="investigation.max_response_total"
                outlined
                hide-details="auto"
                dense
                placeholder="Nombre total de réponses autorisées"
            />
          </v-col>

          <v-col cols="6">
            <p class="font-weight-medium mb-2 required">
              Nombre de réponses par jour
            </p>
            <v-text-field
                v-model="investigation.max_response_per_day"
                outlined
                dense
                hide-details="auto"
                placeholder="Maximum par jour"
            />
          </v-col>

          <v-col cols="6">
            <p class="font-weight-medium mb-2 required">
              Nombre de réponses par semaine
            </p>
            <v-text-field
                v-model="investigation.max_response_per_week"
                outlined
                hide-details="auto"
                dense
                placeholder="Maximum par semaine"
            />
          </v-col>

          <v-col cols="6">
            <p class="font-weight-medium mb-2 required">
              Nombre de réponses par mois
            </p>
            <v-text-field
                v-model="investigation.max_response_per_month"
                outlined
                dense
                hide-details="auto"
                placeholder="Maximum par mois"
            />
          </v-col>


          <v-col cols="6">
            <p class="font-weight-medium mb-2">
              Nombre maximum de réponses validées (optionnel)
            </p>
            <v-text-field
                v-model="investigation.max_validated"
                outlined
                dense
                hide-details="auto"
                placeholder="Nombre maximum de réponses validées"
                type="number"
            />
          </v-col>

          <v-col cols="12">

            <v-switch
                v-model="investigation.use_grading_criteria"
                class="pt-0 pa-0 ma-0"
                color="success"
                label="Appliquer les critères de notation"
            />

            <div v-if="investigation.use_grading_criteria">

              <v-simple-table class="rounded table-border mb-3">
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th width="40%">Règle</th>
                    <th width="30%">Clé statistiques</th>
                    <th>Note</th>
                    <th>Attribue les points</th>
                    <th></th>
                  </tr>
                  </thead>

                  <tbody>
                  <tr
                      v-for="(item, ind) in investigation.grading_rules"
                      :key="item.name || ind"
                  >
                    <td>
                      <v-text-field
                          v-model="item.rule"
                          placeholder="Ex : Respect planogramme"
                      />
                    </td>

                    <td>
                      <v-text-field
                          v-model="item.key"
                          placeholder="Ex : planogramme"
                      />
                    </td>

                    <td>
                      <v-text-field
                          v-model="item.note"
                          placeholder="Ex : 10"
                          type="number"
                          min="0"
                          max="100"
                      />
                    </td>

                    <td>
                      <v-switch v-model="item.award_points" color="success"/>
                    </td>

                    <td>
                      <v-icon
                          color="red"
                          :disabled="investigation.grading_rules.length === 1"
                          @click="investigation.grading_rules.splice(ind, 1)"
                      >
                        mdi-close
                      </v-icon>
                    </td>
                  </tr>

                  <tr v-if="!investigation.grading_rules.length">
                    <td colspan="4"></td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <div class="text-center">
                <v-btn
                    fab
                    depressed
                    color="primary"
                    small
                    @click="investigation.grading_rules.push({
      key: '',
      rule: '',
      note: null,
      award_points: investigation.grading_rules.length === 0
    })"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </div>
            </div>

            <div v-if="investigation.use_grading_criteria">
              <v-simple-table class="rounded table-border mb-3 mt-5">
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class="text-left">Sku</th>
                    <th class="text-left">Clé statistiques</th>
                    <th width="20"></th>
                  </tr>
                  </thead>

                  <tbody>
                  <tr
                      v-for="(item, investigationIndex) in investigation.skus"
                      :key="investigationIndex"
                  >

                    <td>
                      <v-text-field
                          v-model="item.sku"
                          placeholder="Ex : Poulet XL"
                      />
                    </td>

                    <td>
                      <v-text-field
                          v-model="item.key"
                          placeholder="Ex : poulet_xl"
                      />
                    </td>

                    <td>
                      <v-icon
                          color="red"
                          :disabled="investigation.skus.length === 1"
                          @click="investigation.skus.splice(investigationIndex, 1)"
                      >
                        mdi-close
                      </v-icon>
                    </td>
                  </tr>
                  <tr v-if="!investigation.skus.length">
                    <td colspan="25">

                    </td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <div class="text-center">
                <v-btn fab depressed color="primary" small
                       @click="investigation.skus.push({ sku: '',key: '',})">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </div>
            </div>

            <v-switch
                v-model="investigation.is_ai_verified"
                class="pt-0 pa-0 ma-0"
                color="success"
                label="Vérification automatique par IA"
            />

            <v-switch v-model="investigation.is_active"
                      class="pt-0 pa-0 ma-0"
                      color="success"
                      label="Active ?"></v-switch>

            <v-switch class="pt-0 pa-0 ma-0"
                      v-model="investigation.for_all_users"
                      color="success"
                      label="Envoyer à tous les utilisateurs ?"></v-switch>

            <v-tabs v-if="!investigation.for_all_users">
              <v-tab class="text-none" @click="$refs.assignmentDialog.open(i)">
                ({{ investigation.user_ids.length }}) Affecter les utilisateurs *
                <v-icon right>mdi-arrow-right</v-icon>
              </v-tab>
            </v-tabs>

            <v-autocomplete v-if="investigation.for_all_users"
                            :items="databases"
                            v-model="investigation.excluded_database_ids"
                            multiple
                            chips
                            small-chips
                            deletable-chips
                            clearable
                            dense
                            label="Bases de données exclues"
                            outlined
                            item-text="name"
                            item-value="id"></v-autocomplete>

          </v-col>

        </v-row>
      </v-card-text>

      <v-divider/>

      <v-card-actions>

        <v-btn color="gifty"
               fab
               dark
               small
               depressed>
               <span class="f-15">
                  {{ i + 1 }}
               </span>
        </v-btn>

        <v-spacer/>

        <v-menu bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                text
                color="red"
                small
                v-bind="attrs"
                v-on="on"
                :disabled="campaign.investigations.length === 1"
            >
              <v-icon left>mdi-delete-outline</v-icon>
              Supprimer
            </v-btn>
          </template>
          <v-list>

            <v-list-item @click="deleteInvestigation(i)">
              <v-list-item-avatar>
                <v-icon color="red">mdi-trash-can</v-icon>
              </v-list-item-avatar>
              <v-list-item-title>Confirmer la suppression</v-list-item-title>
            </v-list-item>

            <v-list-item link>
              <v-list-item-avatar>
                <v-icon>mdi-close</v-icon>
              </v-list-item-avatar>
              <v-list-item-title>Annuler</v-list-item-title>
            </v-list-item>

          </v-list>
        </v-menu>

        <v-btn text
               color="grey darken-2"
               small
               @click="duplicateInvestigation(investigation)">
          <v-icon left>mdi-content-copy</v-icon>
          Dupliquer
        </v-btn>

      </v-card-actions>

    </v-card>

    <div class="text-center mt-3">
      <v-btn fab
             color="primary"
             depressed
             small
             @click="addInvestigation">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </div>

    <AssignmentDialog ref="assignmentDialog" :campaign="campaign"/>

  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import AssignmentDialog from './AssignmentDialog'

export default {
  props: ['campaign'],
  components: {
    AssignmentDialog
  },
  data() {
    return {
      isLoading: false,
      errors: [],
      databases: [],
      FILE_URL: process.env.VUE_APP_FILE_URL,
    }
  },
  methods: {
    getDatabases() {
      HTTP.get('/v1/opus/campaigns/databases').then((res) => {
        this.databases = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    uploadPhotos(files, investigationIndex) {
      if (files && files.length) {
        for (let i = 0; i < files.length; i++) {
          this.isLoading = true
          this.errors = []
          let formData = new FormData()
          formData.append('image', files[i])
          HTTP.post('/v1/opus/campaigns/upload/image', formData).then((res) => {
            this.isLoading = false
            this.campaign.investigations[investigationIndex].images.push(res.data.data)
          }).catch(err => {
            this.$errorMessage = "Une erreur ç'est produit veuillez le corriger."
            this.errors = err.response.data.errors
            this.isLoading = false
            console.log(err)
          })
        }
      }
    },
    uploadTutorialImage(file, investigationIndex) {
      this.isLoading = true
      this.errors = []
      let formData = new FormData()
      formData.append('image', file)
      HTTP.post('/v1/opus/campaigns/upload/image', formData).then((res) => {
        this.isLoading = false
        this.campaign.investigations[investigationIndex].tutorial_image = res.data.data
      }).catch(err => {
        this.$errorMessage = "Une erreur ç'est produit veuillez le corriger."
        this.errors = err.response.data.errors
        this.isLoading = false
        console.log(err)
      })
    },
    removePhoto(photoIndex, investigationIndex) {
      this.campaign.investigations[investigationIndex].images.splice(photoIndex, 1)
    },
    addInvestigation() {
      this.$vuetify.goTo(document.body.scrollHeight - 350)
      this.campaign.investigations.push({
        name: {
          fr: '',
          ar: '',
        },
        start_date: '',
        end_date: '',
        description: {
          fr: '',
          ar: '',
        },
        images: [],
        winning_points: '',
        tutorial_link: '',
        tutorial_image: '',
        max_response_total: 1,
        max_response_per_day: 1,
        max_response_per_week: 1,
        max_response_per_month: 1,
        max_validated: '',
        use_grading_criteria: false,
        grading_rules: [],
        skus: [],
        is_ai_verified: false,
        for_all_users: false,
        user_ids: [],
        excluded_database_ids: [],
        is_active: true,
        tasks: [
          {
            question_type_key: "text",
            answer_type_key: "checkbox",
            question: {},
            number_of_photos: "",
            file: "",
            files: [],
            raw_text: [],
            allow_gallery: false,
            tutorial_link: "",
            tutorial_image: "",
            options: [
              {option: {}},
              {option: {}},
            ],
          }
        ],
      })
    },
    deleteInvestigation(i) {
      this.campaign.investigations.splice(i, 1)
    },
    duplicateInvestigation(investigation) {
      this.$vuetify.goTo(document.body.scrollHeight - 350)

      const copy = JSON.parse(JSON.stringify(investigation))

      // Remove investigation id
      copy.id = null

      // Reset grading rules ids
      if (Array.isArray(copy.grading_rules)) {
        copy.grading_rules = copy.grading_rules.map(rule => ({
          ...rule,
          investigation_id: null,
          id: null,
        }))
      }

      // Reset skus ids
      if (Array.isArray(copy.skus)) {
        copy.skus = copy.skus.map(sku => ({
          ...sku,
          investigation_id: null,
          id: null,
        }))
      }

      // Reset tasks ids
      if (Array.isArray(copy.tasks)) {
        copy.tasks = copy.tasks.map(task => {
          task.id = null

          // Handle task options if exist
          if (Array.isArray(task.options)) {
            task.options = task.options.map(opt => ({
              ...opt,
              id: null,
            }))
          }

          return task
        })
      }

      this.campaign.investigations.push(copy)
    }
  },
  created() {
    this.getDatabases()
  }
}
</script>

<style scoped>

</style>